export async function parseJson(rawData) {
  return JSON.parse(rawData);
}
